import { useEffect } from 'react'
import { useMe } from '@/api/auth'
import { startTour, tourStore, useTourStates } from './state'
import { WELCOME_TOUR_ID } from './tours'

const SESSION_KEY = 'dv.tour.offered'

/**
 * First login: start the welcome tour once, for users who have neither finished nor
 * skipped it (per-user state on the server). Never in automated browsers.
 */
export function useWelcomeTour() {
  const me = useMe().data
  const tours = useTourStates()
  const seen = !!tours.byId[WELCOME_TOUR_ID]
  useEffect(() => {
    if (!me?.user_id || !tours.server || !tours.loaded || seen) return
    if (typeof navigator !== 'undefined' && navigator.webdriver) return
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return
      sessionStorage.setItem(SESSION_KEY, '1')
    } catch {
      /* storage unavailable: still offer once per page load */
    }
    const id = setTimeout(() => {
      if (!tourStore.get().active) startTour(WELCOME_TOUR_ID)
    }, 800)
    return () => clearTimeout(id)
  }, [me?.user_id, tours.server, tours.loaded, seen])
}
